<script>
    import Config from '@/config';
    import {CellGroup, Form, Field, Button} from 'vant';
    import {sendResetPasswordSms, resetPassword} from '@/api';

    export default {
        name: 'SmsLogin',
        components: {
            [Form.name]: Form,
            [Field.name]: Field,
            [Button.name]: Button,
            [CellGroup.name]: CellGroup
        },
        data() {
            return {
                mobile: '',
                password: '',
                code: '',
                codeText: '获取验证码',
                codeEnable: false,

                gzBind: false,
                loading: false,
                sending: false,
                buttonEnable: false,

                loadingText: '处理中'
            };
        },
        created() {
            if (this.$route.query.gzBind) {
                this.gzBind = true;
            }
            window.document.title = '速电通-重置密码';
        },
        methods: {
            setButtonEnable() {
                this.codeEnable = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/g.test(this.mobile) && !this.sending;
                this.buttonEnable = this.mobile && this.code && this.password && /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/g.test(this.mobile)
                    && /^\d{4,6}$/g.test(this.code) && this.password.length >= 6;
            },
            getCode() {
                if (!this.codeEnable || this.sending) {
                    return;
                }

                this.sending = true;
                sendResetPasswordSms(this.mobile).then(response => {
                    if (response.data.code === Config.successCode) {
                        this.countDown();
                    }
                });
            },
            countDown() {
                let waitTimeSeconds = 60;
                let intervalId = setInterval(() => {
                    if (waitTimeSeconds === 0) {
                        clearInterval(intervalId);
                        this.sending = false;
                        this.codeText = '发送验证码';
                        this.codeEnable = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/g.test(this.mobile);
                    } else {
                        this.codeText = waitTimeSeconds-- + '秒后重新获取';
                    }
                }, 1000);
            },
            onSubmit() {
                if (!this.buttonEnable) {
                    return;
                }

                this.loading = true;
                resetPassword(this.mobile, this.password, this.code).then(response => {
                    if (response.data.code === Config.successCode) {
                        this.$router.replace({name: 'passwordLogin', params: {gzBind: this.gzBind, token: this.$route.query.token}})
                    }
                }).finally(() => {
                    this.loading = false;
                });
            }
        }
    }
</script>

<template>
    <div class="reset-password">
        <img class="logo" alt="速电通" src="../assets/logo.png">
        <van-form @submit="onSubmit">
            <van-cell-group>
                <van-field clearable focus type="number" minlength="11" maxlength="11" label="手机号" placeholder="请输入手机号" titleWidth="60px" autocomplete="off" v-model="mobile" @input="setButtonEnable"/>
                <van-field clearable center use-button-slot type="number" minlength="4" maxlength="6" label="验证码" placeholder="请输入6位数字" titleWidth="60px" autocomplete="off" v-model="code" @input="setButtonEnable">
                    <van-button plain slot="button" color="#009251" size="small" @click="getCode" :disabled="!codeEnable">{{codeText}}</van-button>
                </van-field>
                <van-field clearable name="password" type="password" minlength="6" maxlength="16" label="密 码" placeholder="请输入新密码" titleWidth="60px" v-model="password" @input="setButtonEnable"/>
            </van-cell-group>
            <div class="button">
                <van-button round block color="#009251" native-type="submit" :loading-text="loadingText" :loading="loading" :disabled="!buttonEnable">
                    重置密码
                </van-button>
            </div>
        </van-form>
    </div>
</template>

<style scoped lang="stylus">
    .reset-password
        text-align center

    .reset-password .logo
        height 50px
        width: 100px
        margin 24px

    .reset-password .button
        margin: 24px

        .van-button
            box-shadow 0 3px 6px 1px rgba(0, 146, 81, 0.41)
</style>
